import React from "react";
import "../style/Home.css";



function Home() {
  return (
    <div className="edu-container">
      <h2>About EDU</h2>
      <p>
      Outbox EDU leverages boot camps to train individuals with limited or no experience in software development.
      Breadcrumb
      Learn how to code by leveraging our experienced industry facilitators, alumni community and partners. Join one of our two-month or three-month immersive programs. Get ready to work.


      </p>
      <p>
      Get an opportunity to work on industry projects, learn from experience so as to develop your skills and portfolio
      Receive expert advise on how to prepare for the marketplace. This ranges from creating your online profile to how-to communicate well.
      </p>
     
    
     
     
    </div>
  );
}

export default Home;
